<div class="modal-header">
  <h5 class="modal-title">Cadastro de Gestor Municipal</h5>
</div>

<div class="modal-body">
  <p class="modal-descricao">
    Informe o CNPJ do município e seu CPF para verificar e cadastrar seu acesso
    como gestor municipal.
  </p>

  <form [formGroup]="form" novalidate>
    <div class="form-field">
      <label for="cnpj">CNPJ do Município</label>
      <input
        id="cnpj"
        type="text"
        formControlName="cnpj"
        mask="00.000.000/0000-00"
        placeholder="00.000.000/0000-00"
        class="form-control"
        [class.field-error-input]="cnpjInvalido"
      />
      @if (cnpjInvalido) {
        <span class="field-error">CNPJ é obrigatório e deve ser válido.</span>
      }
    </div>

    <div class="form-field">
      <label for="cpf">CPF do Responsável</label>
      <input
        id="cpf"
        type="text"
        formControlName="cpf"
        mask="000.000.000-00"
        placeholder="000.000.000-00"
        class="form-control"
        [class.field-error-input]="cpfInvalido"
      />
      @if (cpfInvalido) {
        <span class="field-error">CPF é obrigatório e deve ser válido.</span>
      }
    </div>
  </form>
</div>

<div class="modal-footer">
  <div class="modal-actions">
    <button
      type="button"
      class="br-button me-2"
      (click)="fechar()"
      [disabled]="carregando"
    >
      Cancelar
    </button>
    <button type="button" (click)="cadastrar()" class="br-button primary" [disabled]="carregando">
      @if (carregando) {
        <span class="spinner"></span> 
        Verificando...
      } @else {
        Cadastrar
      }
    </button>
  </div>
</div>
